// extracted by mini-css-extract-plugin
export default {"bloc":"album_bloc__YiMwj","texte_1":"album_texte_1__45-gg","texte_2":"album_texte_2__7nFDg"};